import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import {Chip, makeStyles, TextField} from "@material-ui/core";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/theme-tomorrow";
import "ace-builds/src-noconflict/ext-language_tools"
import DialogWrapper from "../../../../../../../../../Utils/Form/FormDynamic/Fields/ScriptType/DialogWrapper";
import PopoverWrapper from "../../../../../../../../../Utils/Form/FormDynamic/Fields/ScriptType/PopoverWrapper";

const useStyles = makeStyles(() => ({
    valueInputRoot: {
        paddingRight: 0
    }
}));

const ValueInput = (props) => {
    const {path, param, paramIndex, actionIndex, currentParam, setValue, valueName, createParam, disabled} = props;
    const classes = useStyles();
    const inputName = valueName ? valueName : 'value';
    const [editChip, setEditChip] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [editChipIndex, setEditChipIndex] = useState(null);
    const onChangeInput = (e) => {
        openEditChip(e);
        setInputValue(e.target.value)
    };
    const onKeyDownInput = (e) => {
        if ((e.key === 'Tab' && !e.shiftKey) && (param.length - 1 === paramIndex)) {
            createParam(actionIndex, paramIndex + 1)
        }
    };
    const onKeyDownChip = (e, index) => {
        if (e.key === 'Enter') {
            openEditChip(e, index)
        }
    };
    const openEditChip = (e, index) => {
        if (index !== undefined && !disabled) {
            setEditChip(e.currentTarget);
            setEditChipIndex(index);
            return;
        }
        setEditChipIndex(currentParam.value ? currentParam.value.length : 0);
        setEditChip(e.currentTarget, currentParam.value ? currentParam.value.length : 0)
    };
    const closeEditChip = () => {
        setEditChip(null);
        setEditChipIndex(null);
        setInputValue('')
    };
    const onSaveChip = (value) => {
        setValue(value, `${path}.param.${paramIndex}.${inputName}.${editChipIndex}`);
        closeEditChip();
    };
    return (
        <>
            <Autocomplete
                freeSolo
                multiple
                open={false}
                disabled={disabled}
                size="small"
                onKeyDown={onKeyDownInput}
                classes={{inputRoot: classes.valueInputRoot}}
                value={currentParam[inputName] || []}
                inputValue={''}
                onChange={(event, newValue) => setValue(newValue, `${path}.param.${paramIndex}.${inputName}`)}
                closeIcon={<></>}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip
                            label={option}
                            size="small"
                            onKeyDown={e => onKeyDownChip(e, index)}
                            onDoubleClick={(e) => openEditChip(e, index)}
                            {...getTagProps({index})}

                        />
                    ))
                }
                renderInput={params => (
                    <TextField
                        {...params}
                        onChange={(e) => onChangeInput(e)}
                        value={''}
                        InputProps={{
                            ...params.InputProps,
                            disableUnderline: true
                        }}
                        fullWidth
                    />
                )}
                options={[]}
            />
            <ValueInputChipEdit
                open={editChip}
                onClose={closeEditChip}
                index={editChipIndex}
                value={currentParam}
                inputValue={inputValue}
                setValue={onSaveChip}
            />
        </>
    )
};
export default ValueInput

ValueInput.propTypes = {
    path: PropTypes.string,
    param: PropTypes.array,
    paramIndex: PropTypes.number,
    actionIndex: PropTypes.number,
    currentParam: PropTypes.object,
    setValue: PropTypes.func,
    valueName: PropTypes.string,
    createParam: PropTypes.func,
    disabled: PropTypes.bool
};

const ValueInputChipEdit = ({open, onClose, index, value, inputValue, setValue}) => {
    const [currentValue, setCurrentValue] = useState('');
    const [fullScreen, setFullScreen] = useState(false);
    const onChange = (value) => {
        setCurrentValue(value)
    };
    const onKeyDown = (e) => {
        if (e.ctrlKey && e.key === 's') {
            e.stopPropagation();
            e.preventDefault();
            setValue(currentValue)
        }
    };

    function toggleFullScreen() {
        setFullScreen(prev => !prev);
    }

    useEffect(() => {
        if (inputValue.length) {
            setCurrentValue(inputValue);
            return
        }
        if (open && value && index !== undefined) {
            setCurrentValue(value.value ? value.value[index] : inputValue)
        }
    }, [open]);
    return (
        fullScreen ? (
            <DialogWrapper
                apply={() => setValue(currentValue)}
                onClose={onClose}
                open={open}
                toggleFullScreen={toggleFullScreen}
                title={'Script'}
            >
                <div style={{padding: 5, width: '100%', height: '100%'}} onKeyDown={(event => onKeyDown(event))}>
                    <AceEditor
                        mode="javascript"
                        width={'100%'}
                        height={'100%'}
                        focus
                        theme="tomorrow"
                        value={currentValue}
                        onChange={(value, stat) => onChange(value, stat)}
                        name="UNIQUE_ID_OF_DIV_"
                        setOptions={{
                            enableBasicAutocompletion: true,
                            enableSnippets: true,
                            useWorker: false
                            //enableLiveAutocompletion: true,
                        }}
                    />
                </div>
            </DialogWrapper>
        ) : (
            <PopoverWrapper
                title={'Script'}
                toggleFullScreen={toggleFullScreen}
                open={open}
                onClose={onClose}
                apply={() => setValue(currentValue)}
            >
                <div style={{width: '100%'}} onKeyDown={(event => onKeyDown(event))}>
                    <AceEditor
                        mode="javascript"
                        width={'100%'}
                        height={493}
                        focus
                        theme="tomorrow"
                        value={currentValue}
                        onChange={(value, stat) => onChange(value, stat)}
                        name="UNIQUE_ID_OF_DIV"
                        setOptions={{
                            enableBasicAutocompletion: true,
                            enableSnippets: true,
                            //useWorker: true
                            //enableLiveAutocompletion: true,
                        }}
                    />
                </div>
            </PopoverWrapper>
        )
    )
};